/* QUESTIONS */
// @ts-nocheck

import gsap from "gsap";
import { TextPlugin } from "gsap/TextPlugin"; 
gsap.registerPlugin(TextPlugin);

import { Countdown } from "./trivia/countdown";
import { StartTrivia } from "./trivia/trivia";
import { optionSelect } from "./trivia/optionSelect"
import { functionsWindow } from "./trivia/window"
import { viewShow, printFinalTrivia } from "./trivia/functions"
import Petition from "../../../modules/petition"

import { AudioButton } from "./trivia/Audio"

declare global {
  interface Window {
    dama: any;
    datalayer: any;
    SHA256: any;
    drupalSettings: any;
    statusPermits: any;
    welcomeTrivia: any
  }
}

/**
 * Module Question
 *
 */
 export const Question = () => {
  console.log('questions1')

  const pt = new Petition();
  startTrivia()

};

function startTrivia() {
  let counter = document.getElementById("triviaTime");
  let time = counter.dataset.time;
  let newTime = time ? parseInt(time) : 10;
  welcomeTrivia(newTime);
  optionSelect();
  // //AudioButton Initialized
  AudioButton.init();
}

/**
 *
 * @param newTime
 */
const welcomeTrivia = (newTime: number) => {
  viewShow(1)
  let welcomeTriviaCont = document.getElementById("welcomeTrivia");
  let refwelcomeBtn = welcomeTriviaCont.querySelector(".welcome-trivia__btn");
  /**
   * Click to start trivia
   */
  refwelcomeBtn.addEventListener("click", () => {
    // if (window.statusPermits == "undefined" || window.statusPermits == null) {
    //   window.statusPermits = true;
    // }
    // Show Trivia
    showTrivia(welcomeTriviaCont);
    // Countdown Initialized
    Countdown.init(newTime);
    // Trivia Initialized
    StartTrivia();
  });
}

/**
 *
 * @param welcomeTriviaCont
 */
const showTrivia = (welcomeTriviaCont: any) => {
  let triviaCont = document.getElementById("triviaContainer");
  viewShow(2)
  setTimeout(() => triviaCont.classList.add("trivia--started"), 300);
};

const hideLoader = () => {
  let refLoader = document.getElementById("triviaLoader")
  refLoader.classList.add("loader--hidden");
}

// const setNameUser = (userName: string) => {
//   gsap.to('#userName', { duration: 2, text: `¡BIENVENID@ ${userName.split(" ")[0]}!` })
// }